import siting from "@/assets/teamoverview/videocompositing.png";
import entel from "@/assets/teamoverview/entel.png";
import merber from "@/assets/teamoverview/merber.png";
import spjrrd from "@/assets/teamoverview/spjrrd.png";
import spjrts from "@/assets/teamoverview/spjrts.png";
import twds from '@/assets/teamoverview/twds.png'
import szrsc from '@/assets/teamoverview/szrsc.png'
import syfk from '@/assets/teamoverview/syfk.png'
import glyzh from '@/assets/teamoverview/glyzh.png'
import aisp from '@/assets/teamoverview/ai-spjx.png'
import aitp from '@/assets/teamoverview/ai-wbtp.png'
import jzbd from '@/assets/teamoverview/jzbd.png'
export const MapObjs = {
  1: {
    desc: '总视频点数: ',
    title: '视频点数剩余',
    unit: '条',
    icon: siting
  },
  2: {
    desc: '总成员席位: ',
    title: '成员席位剩余',
    unit: '位',
    icon: merber
  },
  3: {
    desc: '总存储空间: ',
    title: '团队空间剩余',
    unit: '',
    icon: entel
  },
  4: {
    desc: '矩阵绑定点数: ',
    title: '矩阵绑定点数剩余',
    unit: '个',
    icon: jzbd
  },
  5: {
    desc: '数字人形象: ',
    title: '数字人形象剩余',
    unit: '',
    icon: szrsc
  },
  6: {
    desc: '数字人时长: ',
    title: '数字人时长剩余',
    unit: '秒',
    icon: szrsc
  },
  7: {
    desc: '声音复刻: ',
    title: '声音复刻剩余',
    unit: '个',
    icon: syfk
  },
  8: {
    title: '声音复刻时长: ',
    desc: '声音复刻时长剩余',
    unit: '秒',
    icon: syfk
  },
  9: {
    desc: 'AI文本图片功能: ',
    title: 'AI文本图片功能剩余',
    unit: '个',
    icon: aitp
  },
  10: {
    desc: 'AI视频解析脚本: ',
    title: 'AI视频解析脚本剩余',
    unit: '个',
    icon: aisp
  },
  11: {
    desc: '管理员账号: ',
    title: '管理员账号剩余',
    unit: '个',
    icon: glyzh
  },
  12: {
    desc: '运营培训: ',
    title: '运营培训剩余',
    unit: '个'
  },
  13: {
    desc: '陪跑落地: ',
    title: '陪跑落地剩余',
    unit: '个'
  },
  14: {
    desc: '视频加热条数: ',
    title: '视频加热条数剩余',
    unit: '条',
    icon: spjrts
  },
  15: {
    title: '一键成片: ',
    desc: '一键成片剩余',
    unit: '个'
  },
  16: {
    desc: '图文点数: ',
    title: '图文点数剩余',
    unit: '个',
    icon: twds
  },
  17: {
    title: '视频加热热度: ',
    desc: '视频加热热度剩余',
    unit: '点',
    icon: spjrrd
  },
  19: {
    desc: 'GEO素材空间: ',
    title: 'GEO素材空间剩余',
    unit: ''
  },
  20: {
    title: '关键词个数: ',
    desc: '关键词个数剩余',
    unit: '个'
  },
  21: {
    desc: '拓词个数: ',
    title: '拓词个数剩余',
    unit: '个'
  },
  23: {
    desc: '权威发布文章数: ',
    title: '权威发布文章数剩余',
    unit: '篇'
  }
}
